export default __webpack_public_path__ + "static/media/icon_ion-help-outline.c6480633.svg";